<ng-template #content>
    <ng-content></ng-content>
</ng-template>

@if (useRouterLink) {
    <a
        [routerLink]="[link]"
        [attr.title]="title ? title : null"
        [ngClass]="classes">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
} @else {
    <a
        [href]="link"
        [target]="externalLink ? '_blank' : '_self'"
        [ngClass]="classes"
        [attr.title]="title ? title : null"
        [attr.rel]="externalLink ? 'noopener noreferrer' : null">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
}
